import React, { useContext, useEffect, useMemo, useState } from "react";
import { useHistory, useParams } from "react-router-dom";

import { AppContext } from "../../../../core/context/appContextProvider";
import RoutingPaths from "../../../../core/routing/routingPaths";
import useRole from "../../../../core/routing/useRole";
import {
  DistributionupdateStatus,
  getDistributionReviewSummary,
  updateDistributionsStatus,
} from "../../../../services/distributions.service";
import { useDistributionDetailsEffect } from "../../../../services/hooks/useDistributionsEffect/useDistributionDetailsEffect.hook";
import { DistributionReviewsSummary } from "../../../../utils/types/distributions.type";
import { ScopeRole } from "../../../../utils/types/user.type";
import {
  DISTRIBUTION_DOCUMENT_GET_ERROR,
  DISTRIBUTION_REVIEW_DOCUMENT_SUCCESS,
  DISTRIBUTION_UPDATE_STATUS_ERROR,
} from "../Constants";

type RouteProp = {
  id: string;
};

import { DistributionReviewersList } from "../Constants";

export const UsePublish = () => {
  const [reviewSummary, setReviewSummary] =
    useState<DistributionReviewsSummary>();
  const [status, setStatus] = useState<string | undefined>(undefined);
  const [loading, setLoading] = useState<boolean>(false);
  const [confirmPublish, setConfirmPublish] = useState<boolean>(false);
  const [toPublish, setToPublish] = useState<boolean>(false);
  const [toReview, setToReview] = useState<boolean>(false);
  const params = useParams<RouteProp>();
  const { informationAlert, state } = useContext(AppContext);
  const { distributions } = useDistributionDetailsEffect(params?.id);
  const [formattedReviewSummary, setFormattedReviewSummary] = useState<any>();
  const [usernames, setUsernames] = useState<string[]>([]);
  const history = useHistory();
  const headerTitles = useMemo(() => {
    const headers =
      reviewSummary?.reviews[0].approvals.map((approval) => approval.role) ||
      [];
    const filteredHeaders = headers.filter((header, index) => {
      return headers.indexOf(header) === index;
    });

    return filteredHeaders;
  }, [reviewSummary]);
  const dummyTitle: number[] = [1, 2, 3, 4, 5];
  const { hasRole: isSuperAdminOrClientAdmin } = useRole([
    ScopeRole.SUPER_ADMIN,
    ScopeRole.ARK_CLIENT_ADMIN,
    ScopeRole.BASIC_ADMIN,
  ]);

  useEffect(() => {
    getSummaryOfReviews();
  }, [params?.id]);

  useEffect(() => {
    setStatus(distributions?.status);
  }, [distributions]);
  const selectReviewer = (member: string) => {
    switch (member) {
      case DistributionReviewersList.Associate:
        return "Associate";
      case DistributionReviewersList.Director:
        return "Director";
      case DistributionReviewersList.FundController:
        return "Fund Controller";
      case DistributionReviewersList.FundUserReadOnly:
        return "Fund User Read Only";
      case DistributionReviewersList.Manager:
        return "Manager";
      default:
        return "";
    }
  };
  const allowPublish = useMemo(() => {
    return usernames.includes(
      state.loginUser.currentUser?.username.toLowerCase() || ""
    );
  }, [usernames]);
  const getSummaryOfReviews = async () => {
    try {
      setLoading(true);
      await getDistributionReviewSummary(params?.id || "").then((data) => {
        setReviewSummary(data);
        let reviewerApprovals = false;
        const createdBy = data?.createdBy;
        let isFlaggedReview = false;
        let tosubmitReview = false;
        const formattedReviews = [];
        const userNameList: string[] = [];

        for (const review of data.reviews) {
          const approvals: any = { investor: review.investor };

          for (const approval of review.approvals) {
            !userNameList.includes(approval?.username?.toLowerCase()) &&
              userNameList.push(approval?.username?.toLowerCase());
            approvals[approval.role] = approvals[approval.role]
              ? [
                  ...approvals[approval.role],
                  {
                    id: approval.id,
                    username: approval.username,
                    tenantId: approval.tenantId,
                    approved: approval.approved,
                  },
                ]
              : [
                  {
                    id: approval.id,
                    username: approval.username,
                    tenantId: approval.tenantId,
                    approved: approval.approved,
                  },
                ];
          }

          formattedReviews.push(approvals);
        }

        setFormattedReviewSummary(formattedReviews);
        setUsernames(userNameList);
        data?.reviews?.forEach((review) => {
          const countApprovals = review.approvals.length;
          let count = 0;

          review.approvals.forEach((approval) => {
            if (approval.approved === false) {
              isFlaggedReview = true;

              return;
            }

            if (approval.approved === true) {
              count = count + 1;
            }

            if (approval.approved === true && approval.username === createdBy) {
              tosubmitReview = true;
            }
          });
          if (count === countApprovals) {
            reviewerApprovals = true;
          }
        });

        const publish = !isFlaggedReview && reviewerApprovals;
        const allowsubmitreview = !isFlaggedReview && tosubmitReview;

        setToPublish(publish);
        setToReview(allowsubmitreview);
      });
      setLoading(false);
    } catch (err) {
      setLoading(false);
    }
  };
  const allowEdit = useMemo(() => {
    if (params?.id !== "new") {
      if (
        state.loginUser.currentUser?.username.toLowerCase() ===
          distributions?.createdBy?.toLowerCase() &&
        distributions?.status?.toLowerCase() !== "published"
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }, [params.id, distributions, state]);
  const submitReview = async () => {
    try {
      setLoading(true);
      setStatus("REVIEWING");
      await DistributionupdateStatus(params?.id, "REVIEWING");
      setLoading(false);
      informationAlert(DISTRIBUTION_REVIEW_DOCUMENT_SUCCESS, "success");
      setTimeout(() => {
        history.push(RoutingPaths.Distributions);
      }, 1000);
    } catch (error) {
      informationAlert(DISTRIBUTION_DOCUMENT_GET_ERROR, "error");
      setLoading(false);
    }
  };

  const handlePublishCancel = () => {
    setConfirmPublish(false);
  };

  const handlePublishConfirm = async () => {
    try {
      setStatus("PUBLISHED");
      setConfirmPublish(false);
      await updateDistributionsStatus(params?.id, "PUBLISHED");
      setTimeout(() => {
        history.push(RoutingPaths.Distributions);
      }, 1000);
    } catch (error) {
      setStatus(distributions?.status);
      informationAlert(DISTRIBUTION_UPDATE_STATUS_ERROR, "error");
    }
  };

  return {
    reviewSummary,
    status,
    selectReviewer,
    submitReview,
    confirmPublish,
    loading,
    handlePublishCancel,
    handlePublishConfirm,
    toPublish,
    setConfirmPublish,
    isSuperAdminOrClientAdmin,
    toReview,
    allowEdit,
    headerTitles,
    dummyTitle,
    formattedReviewSummary,
    allowPublish,
  };
};
